import { useContext } from "react";
import { PayoutInformationContext } from "./PayoutInformationContext";
import { PayoutInformationContextProps } from "./types";

export const usePayoutInformationContext =
    (): PayoutInformationContextProps => {
        const context = useContext(PayoutInformationContext);

        if (!context) {
            throw new Error(
                "usePayoutInformationContext must be used within a PayoutInformationContextProvider",
            );
        }

        return context;
    };
